import React from 'react';

const Top50CompanyAccountsPage = () => {
  return <div>Top50 업체별 결산</div>;
};

export default Top50CompanyAccountsPage;
